import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { EditorialArticleShell, useEditorialNav } from './EditorialArticleShell';
import { getExamContent, getExamKeyFromHost, getExamSiteOrigin } from './examContext';

export default function ExamCaseStudyPage() {
  const { slug } = useParams();
  const examKey = getExamKeyFromHost();
  const { navigate } = useEditorialNav(examKey);
  const content = getExamContent(examKey);
  const caseStudy = content.case_studies?.[slug];

  if (!caseStudy) {
    return <Navigate to="/insights" replace />;
  }

  const origin = getExamSiteOrigin(examKey);
  const pageUrl = `${origin}/case-studies/${slug}`;
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Article",
        "headline": caseStudy.title,
        "description": caseStudy.meta,
        "url": pageUrl,
        "publisher": { "@type": "Organization", "name": "ivori", "url": "https://ivoriai.com/" }
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Home", "item": origin },
          { "@type": "ListItem", "position": 2, "name": "Case Studies", "item": `${origin}/case-studies` },
          { "@type": "ListItem", "position": 3, "name": caseStudy.title, "item": pageUrl }
        ]
      },
      {
        "@type": caseStudy.org_type || "EducationalOrganization",
        "name": caseStudy.org_name
      }
    ]
  };

  return (
    <EditorialArticleShell
      examKey={examKey}
      title={`${caseStudy.title} | Case Study`}
      description={caseStudy.meta}
      url={pageUrl}
      schema={schema}
      backLabel="← Back to Main"
      onBack={() => navigate(-1)}
      eyebrow={caseStudy.eyebrow}
      heading={caseStudy.title}
      meta={caseStudy.meta}
      bodyHtml={caseStudy.body_html}
    >
      {Array.isArray(caseStudy.stat_grid) && caseStudy.stat_grid.length > 0 && (
        <section className="lnat-ed-post-section">
          <div className="lnat-ed-container lnat-ed-stat-grid">
            {caseStudy.stat_grid.map((stat, idx) => (
              <div className="lnat-ed-stat-card" key={idx}>
                <div className="lnat-ed-stat-number">{stat.value}</div>
                <div className="lnat-ed-stat-label">{stat.label}</div>
                {stat.desc && <div className="lnat-ed-stat-desc">{stat.desc}</div>}
              </div>
            ))}
          </div>
        </section>
      )}
    </EditorialArticleShell>
  );
}
